export const userRightTypes = {
  // -- Project
  PROJECT_READ: 'PROJECT_READ',
  PROJECT_DELETE: 'PROJECT_DELETE',
  PROJECT_EDIT: 'PROJECT_EDIT',
  // -- Project's Attributes
  PROJECT_ATTRIBUTES_READ: 'PROJECT_ATTRIBUTES_READ',
  PROJECT_ATTRIBUTES_DELETE: 'PROJECT_ATTRIBUTES_DELETE',
  PROJECT_ATTRIBUTES_EDIT: 'PROJECT_ATTRIBUTES_EDIT',
  // -- Scenario
  SCENARIO_READ: 'SCENARIO_READ',
  SCENARIO_DELETE: 'SCENARIO_DELETE',
  SCENARIO_EDIT: 'SCENARIO_EDIT',
  // -- Scenario's Attributes
  SCENARIO_ATTRIBUTES_READ: 'SCENARIO_ATTRIBUTES_READ',
  SCENARIO_ATTRIBUTES_DELETE: 'SCENARIO_ATTRIBUTES_DELETE',
  SCENARIO_ATTRIBUTES_EDIT: 'SCENARIO_ATTRIBUTES_EDIT',
  // -- Global Attributes
  GLOBAL_ATTRIBUTES_READ: 'GLOBAL_ATTRIBUTES_READ',
  GLOBAL_ATTRIBUTES_DELETE: 'GLOBAL_ATTRIBUTES_DELETE',
  GLOBAL_ATTRIBUTES_EDIT: 'GLOBAL_ATTRIBUTES_EDIT',
  // -- User
  USER_RIGHTS_READ: 'USER_RIGHTS_READ',
  USER_RIGHTS_DELETE: 'USER_RIGHTS_DELETE',
  USER_RIGHTS_EDIT: 'USER_RIGHTS_EDIT'
}
